// ShineButton.jsx
import React from "react";
import "./css/ShineButton.css";
import { ArrowUpRightIcon } from "@heroicons/react/24/outline";

/**
 * fontSize: optional, number (pixels) or string (e.g. "14px", "0.875rem")
 * style: optional, passed to root button (merged with gradientStyle)
 */
const ShineButton = ({
  className = "",
  id,
  text = "Use This",
  draggable = false,
  icon = "default",
  iconProps = {},
  gradientFrom,
  gradientTo,
  gradientAngle = 135,
  onClick,
  style = {}, // optional root style
  fontSize = null, // optional: number (px) or valid CSS size string
}) => {
  const showIcon = icon !== "none";
  const IconComponent = icon === "default" ? ArrowUpRightIcon : icon;

  const gradientStyle =
    gradientFrom && gradientTo
      ? {
          backgroundImage: `linear-gradient(${gradientAngle}deg, ${gradientFrom}, ${gradientTo})`,
        }
      : {};

  // If fontSize provided, build an inline style for the label.
  // Accept number (px) or string (raw CSS value).
  const labelStyle =
    fontSize == null
      ? {}
      : {
          fontSize: typeof fontSize === "number" ? `${fontSize}px` : fontSize,
          lineHeight: "normal",
        };

  // Merge styles for root button: gradient style should be allowed to be overridden by style prop
  const buttonStyle = { ...gradientStyle, ...style };

  return (
    <button
      id={id}
      className={`shine-btn shine-btn-default ${className}`.trim()}
      draggable={draggable}
      onClick={onClick}
      style={buttonStyle}
    >
      {showIcon && IconComponent && (
        <IconComponent
          className="shine-btn-icon"
          style={{ marginRight: "8px", width: "16px", height: "16px" }}
          {...iconProps}
        />
      )}
      <span className="shine-text" style={labelStyle}>
        {text}
      </span>
      <div className="shine-overlay">
        <div className="shine-glow"></div>
      </div>
    </button>
  );
};

export default ShineButton;
